<template>
    <div class="flex divide-x md:border-x border-b shadow lg:rounded-b-lg h-20 sm:h-24
                bg-skin-b-list-back
                border-skin-b-list-bord" :class="[
            headercolor=='default' ? 'text-skin-b-list-base bg-skin-b-list-back' : '',
            headercolor=='green' ? 'bg-green-100 dark:bg-green-700 text-green-800 dark:text-green-100' : '',
            headercolor=='red' ? 'bg-red-100 dark:bg-red-700 text-red-800 dark:text-red-100' : '',
          ]">
        <div class="flex-none inline-flex">
            <router-link :to="target" custom v-slot="{ navigate }">
                <button type="button" @click="navigate" role="link" class="px-2 sm:px-4 lg:rounded-bl-lg
                        focus:z-10 focus:ring-0 focus:ring-transparent" :class="[
                headercolor=='default' ? 'hover:text-skin-b-base hover:bg-skin-b-list-head' : '',
                headercolor=='green' ? 'hover:text-green-700 dark:hover:text-green-50 hover:bg-green-50 dark:hover:bg-green-600' : '',
                headercolor=='red' ? 'hover:text-red-700 dark:hover:text-red-50 hover:bg-red-50 dark:hover:bg-red-600' : '',
                ]">
                    <IconArrowLeft class="w-8 h-8" />
                </button>
            </router-link>
        </div>
        <div class="inline-flex grow sm:pl-6 truncate">
            <div class="my-auto pr-4 hidden sm:inline-block" :class="[
                    headercolor=='default' ? 'text-skin-b-list-mute' : '',
                    headercolor=='green' ? 'text-green-800 dark:text-green-100' : '',
                    headercolor=='red' ? 'text-red-800 dark:text-red-100' : '',
                ]">
                <slot name="icon"></slot>
            </div>

            <div class="px-4 pt-4 pb-2 w-full my-auto sm:pl-0 truncate">
                <h1 class="font-bold text-xl sm:text-2xl truncate">
                    <span>{{ title }}</span>
                    <span v-if="titleadd"> {{ titleadd }}</span>
                    <span v-if="hassetting" class="cursor-pointer">
                        <router-link :to="settarget" custom v-slot="{ navigate }">
                            <IconSetwheel @click="navigate" class="-mt-1 inline-block ml-2 w-6 h-6" />
                        </router-link>
                    </span>
                </h1>
                <h4 v-if="hassubline" class="font-medium text-lg text-skin-b-list-mute truncate">
                    <slot name="subline"></slot>
                </h4>
                <div v-if="hasmenu" class="w-full">
                    <slot name="menu"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IconArrowLeft from '../icons/IconArrowLeft.vue'
import IconSetwheel from '../icons/IconSetwheel.vue'

export default {
    components: {
        IconArrowLeft, IconSetwheel
    },
    props: {
        headercolor: {
        type: String,
        default: 'default'
      },
        title: String,
        titleadd: {
        type: String,
        default: ''
      },
        hassetting: {
        type: Boolean,
        default: false
      },
        settarget: {
        type: String,
        default: ''
      },
        target: String,
        hassubline: Boolean,
        hasmenu: Boolean
    },
  };
</script>
<style scoped>
</style>
    